import getWithToken from './base/get-with-token'

const getDeviceStats = (date, searchData) => getWithToken(`/dashboard/device-stats?date=${date}`)({
    ...searchData,
})

export default getDeviceStats